import "./App.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Page404 from "./Layout/Page404";
import { ConfigContext, ConfigProvider } from "./Context/ConfigContext";
import routes from "./Routes/Routes";
import AppLayout from "./Layout/AppLayout";
import "./i18n";
import LoginPage from "./Pages/LoginPage";
import Registration from "./Pages/Account/Registration";
import ForgetPassword from "./Pages/Account/ForgetPassword";
import ResetPassword from "./Pages/Account/ResetPassword";
import EmailVerification from "./Pages/Account/EmailVerification";
import AccountLocked from "./Pages/Account/AccountLock";
import Temp from "./Pages/Temp";
import { CartsProvider } from "./Context/CartsContext";
import { useContext, useEffect, useState } from "react";
import { socket } from "./Socket";
import { axiosGet } from "./Apis/axiosMethods";

function App() {
  const { business_id, HandleLogout } = useContext(ConfigContext);
  const [isForceLogout, setIsForceLogout] = useState(false);

  const CheckLogoutStatus = async () => {
    try {
      if (!business_id) return;

      const response = await axiosGet(`/Users/GetLogoutStatus`, { business_id });

      if (response?.success) {
        if (Number(response?.force_log_out) === 1) {
          setIsForceLogout(true);

          setTimeout(() => {
            HandleLogout();
          }, 2000);

        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  let router = createBrowserRouter([
    { path: "/Registration", element: <Registration /> },
    { path: "/Login", element: <LoginPage /> },
    { path: "/Forget-Password", element: <ForgetPassword /> },
    {
      path: "/Reset-Password/:reset_password_token",
      element: <ResetPassword />,
    },
    {
      path: "/EmailVerification/:token",
      element: <EmailVerification />,
    },
    { path: "/Temp", element: <Temp /> },
    { path: "/", element: <LoginPage /> },
    { path: "/*", element: <LoginPage /> },
  ]);

  useEffect(() => {

    if (!business_id) return;

    socket.connect();

    socket.on("connect", () => {
      console.log("Socket Connected :", socket.id);
      socket.emit("register_business", business_id);
    });

    socket.on("disconnect", () => {
      console.log("Socket Disconnected");
    });

    socket.on("force_logout", async () => {
      setIsForceLogout(true);

      setTimeout(() => {
        HandleLogout();
      }, 2000);

    });

    return () => {
      socket.off("connect");
      socket.off("disconnect");
      socket.off("force_logout");
      socket.disconnect();
    };
  }, []);

  useEffect(() => {
    CheckLogoutStatus();
  }, [business_id]);

  if (localStorage.getItem("business_id") && localStorage.getItem("AccountLocked") === "lock") {
    router = createBrowserRouter([
      {
        path: "/*",
        element: <AccountLocked />,
      },
    ]);
  } else if (localStorage.getItem("business_id")) {
    router = createBrowserRouter([
      {
        element: <AppLayout />,
        errorElement: <Page404 />,
        children: routes,
      },
    ]);
  }

  return (
    <ConfigProvider>
      <CartsProvider>
        {isForceLogout && (
          <div className="force-logout-overlay">
            <div className="force-logout-content">
              <img
                src="https://b2badmin.ghayar.com/assets/images/Ghayar.png"
                alt="Ghayar"
                className="force-logout-logo"
              />
              <div className="force-logout-spinner"></div>
              <p>Logging out...</p>
            </div>
          </div>
        )}
        <RouterProvider router={router} />
      </CartsProvider>
    </ConfigProvider>
  );
}

export default App;